import { CampaignStatusIcon } from './campaign-status-icon'
import {
	CAMPAIGN_STATUS_FILTERS,
	CAMPAIGN_STATUS_LABELS,
	CampaignStatusFilter
} from './campaign-status'

interface CampaignStatusPillsProps {
	counts: Record<CampaignStatusFilter, number>
	isSelected: (status: CampaignStatusFilter) => boolean
	onToggle: (status: CampaignStatusFilter) => void
}

/**
 * Active / Paused / Removed toggle pills shown at the top of the Campaigns
 * dropdown. Mirrors the "Ad platforms" filter cards in the Ad accounts
 * dropdown, styled as the DS "Toggle Pill" from Figma (count badge + label +
 * status icon; selection is conveyed by the pill border/fill, the icon always
 * keeps its status color).
 */
export const CampaignStatusPills = ({
	counts,
	isSelected,
	onToggle
}: CampaignStatusPillsProps) => (
	<div className="flex flex-wrap gap-[8px] items-start w-full">
		{CAMPAIGN_STATUS_FILTERS.map((status) => {
			const count = counts[status]
			const selected = isSelected(status)
			return (
				<button
					key={status}
					type="button"
					onClick={() => onToggle(status)}
					aria-pressed={selected}
					className={`
						flex h-[32px] items-center gap-[6px] pl-[7px] pr-[9px] rounded-[8px] border border-solid shadow-[0px_1px_1px_rgba(16,24,40,0.05)] transition-colors
						${
							selected
								? 'bg-t-step-inactive border-[var(--border-brand,#554bfd)]'
								: 'bg-[color:var(--pill-fill)] border-t-checkbox hover:bg-[var(--bg-hover,#f9f9f9)]'
						}
					`}
				>
					<span
						className={`
							flex items-center justify-center h-[14px] px-[2px] rounded-[4px] font-['Host_Grotesk',sans-serif] text-[12px] font-semibold leading-[16px]
							${
								selected
									? 'bg-[#554bfd] text-white'
									: 'bg-bg-plan-fill text-[color:var(--text-tertiary,#9f9ea3)]'
							}
						`}
					>
						{count}
					</span>
					<span
						className={`
							font-['Host_Grotesk',sans-serif] text-[14px] leading-[18px] whitespace-nowrap
							${
								selected
									? 'text-[color:var(--text-primary)] font-medium'
									: 'text-[color:var(--text-secondary)]'
							}
						`}
					>
						{CAMPAIGN_STATUS_LABELS[status]}
					</span>
					<CampaignStatusIcon status={status} />
				</button>
			)
		})}
	</div>
)
